<template>
  <component
    :is="tag"
    class="t-title leading-none subpixel-antialiased tracking-normal"
    :class="[
      SizeClasses[size],
      responsive ? SizeResponsiveClasses[size] : '',
      color,
      classes,
      LeadingClasses[leading],
      bold ? 'font-bold' : 'font-normal',
    ]"
    :critical="critical ? true : null"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
const SizeClasses = {
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
  '6xl': 'text-6xl',
  '7xl': 'text-7xl',
  '8xl': 'text-8xl',
  '9xl': 'text-9xl',
}

const SizeResponsiveClasses = {
  '2xl': 'lg:text-3xl',
  '3xl': 'lg:text-4xl',
  '4xl': 'lg:text-5xl',
  '5xl': 'lg:text-6xl',
  '6xl': 'lg:text-7xl',
  '7xl': 'lg:text-8xl',
  '8xl': 'lg:text-9xl',
  '9xl': 'lg:text-9xl',
}

const LeadingClasses = {
  none: 'leading-none',
  tight: 'leading-tight',
}

export interface propsInterface {
  tag?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  size?: '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl' | '9xl'
  responsive?: boolean
  color?: string
  classes?: string
  bold?: boolean
  critical?: boolean
  leading?: 'none' | 'tight'
}

withDefaults(defineProps<propsInterface>(), {
  tag: 'div',
  size: '4xl',
  responsive: true,
  color: 'text-gray-900',
  classes: 'mb-4',
  bold: false,
  critical: false,
  leading: 'none',
})
</script>
